import React, { useState } from "react";
import "./Login.css";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { loginUser } from "../../store/actions/auth";
import { showToast } from "../../utills/tools";
import { toast, ToastContainer } from "react-toastify";
import PreventSignIn from "../../hoc/preventSignin";

const Login = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData({ ...formData, [id]: value });
  };

  const handleLogin = (e) => {
    e.preventDefault();

    if (!formData.email || !formData.password) {
      return showToast("WARNING", "Please fill in all fields.");
    }

    try {
      // Dispatch login action
      dispatch(loginUser(formData)).then((result) => {
        if (result?.payload?.success) {
          if (result?.payload?.result?.roleId != "0") {
            toast.error("Only Admin User Allowed Access!", {
              position: "top-right", // Use string instead of POSITION.TOP_RIGHT
              autoClose: 600,
              onClose: () => {
                navigate("/");
              },
            });
          }
          toast.success("Login successful!", {
            position: "top-right",
            autoClose: 600,
            onClose: () => {
              navigate("/admin");
            },
          });
        } else {
          toast.error(
            result?.payload?.message || "Unable to login!,try again...",
            {
              position: "top-right", // Use string instead of POSITION.TOP_RIGHT
              autoClose: 600,
              onClose: () => {
                navigate("/");
              },
            }
          );
        }
      });
    } catch (error) {
      // Handle unexpected errors
      toast.success("Unable to login Currently,Try again later!", {
        position: "top-right", // Use string instead of POSITION.TOP_RIGHT
        autoClose: 600,
        onClose: () => {
          navigate("/");
        },
      });
      console.error("Login error:", error);
    }
  };

  const togglePassword = () => {
    setShowPassword((prev) => !prev);
  };

  return (
    <PreventSignIn>
      <div className="login-page">
        <ToastContainer />

        {/* Animated Background */}
        <div className="background">
          <div className="circle"></div>
          <div className="circle"></div>
          <div className="circle"></div>
        </div>

        {/* Login Form */}
        <div className="login-container">
          <h2 className="login-title">Welcome Login</h2>
          <form className="login-form" onSubmit={handleLogin}>
            <div className="form-group">
              <label>Email</label>
              <input
                type="email"
                id="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="Enter your email"
                required
              />
            </div>
            <div className="form-group">
              <label>Password</label>
              <div className="password-wrapper">
                <input
                  type={showPassword ? "text" : "password"}
                  id="password"
                  value={formData.password}
                  onChange={handleChange}
                  placeholder="Enter your password"
                  required
                  autoComplete="current-password"
                />
                <span className="toggle-icon" onClick={togglePassword}>
                  {showPassword ? "👁️" : "🙈"}
                </span>
              </div>
            </div>
            {/* Link to Signup Page */}
            <div className="signup-link mb-2 mr-1 flex justify-end">
              <p>
                Don't have an account? <Link to="/register">Register</Link>
              </p>
            </div>
            <button type="submit" className="login-btn">
              Login
            </button>
          </form>
        </div>
      </div>
    </PreventSignIn>
  );
};

export default Login;
